// Campus photo for /colleges/university-of-miami: CC BY 2.0, by Chad Cooper, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AMain_Gate_University_of_Miami.jpg), checked 2026-10-02 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-miami/; credited under the photo.
const photo = {
    "slug": "university-of-miami",
    "alt": "Palm trees and flagpoles at the main entrance to the University of Miami campus in Coral Gables, Florida",
    "src": "/colleges/university-of-miami/campus-1600.webp",
    "srcSmall": "/colleges/university-of-miami/campus-800.webp",
    "srcMid": "/colleges/university-of-miami/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-miami/og.jpg",
    "title": "Main Gate University of Miami",
    "author": "Chad Cooper",
    "license": "CC BY 2.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/2.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AMain_Gate_University_of_Miami.jpg",
    "read": "2026-10-02"
};

export default photo;
